import moment from "moment";

export function getFormatDate(dateString) {
  if (dateString) return moment(dateString, "D MMMM YYYY HH:mm").format("DD MMM YYYY HH:mm");
  return "";
}

export function formatToDDMMMYYYY(dateStr) {
  const date = moment(dateStr, ["YYYY-MM-DD", "D MMM YYYY", "DD-MM-YYYY", "MMM D, YYYY"]);

  if (!date.isValid()) {
    return "-";
  }

  return date.format("DD MMM YYYY");
}

export const getDatePlusOne = (date) => {
  try {
    const nextDay = new Date(date);
    nextDay.setDate(nextDay.getDate() + 1);

    return nextDay;
  } catch (error) {
    console.error("Error updating dates:", error);
    return date;
  }
  // Create a new Date object and add one day
};
export function getFlushedDate(dateString) {
  if (dateString === "0000-00-00") return null;
  else if (dateString) return new Date(dateString);
  return null;
}

export function convertTimeToDateObj(timeStr) {
  if (!timeStr) return null;

  const momentObj = moment(timeStr, "HH:mm");
  if (!momentObj.isValid()) return null;

  return momentObj.toDate(); // Returns native Date object
}

export function safeDateIsoParts(dateStr, timeStr = "00:00:00") {
  if (!dateStr || !timeStr) return null;
  const m = moment(`${dateStr}T${timeStr}Z`);
  return m.isValid() ? `${m.format("YYYY-MM-DD")}T${timeStr}Z` : null;
}

export const parseSafeMomentDate = (input) => {
  if (!input) return null;

  // 🔒 Explicitly block common garbage values
  const invalidStrings = ["null", "undefined", "NaN", "invalid date", "null null"];
  const normalized = String(input).trim().toLowerCase();

  if (invalidStrings.includes(normalized)) {
    return null;
  }

  const knownFormats = [
    "DD/MM/YYYY",
    "MM/DD/YYYY",
    "YYYY/MM/DD",
    "YYYY-MM-DD",
    "DD-MM-YYYY",
    "MM-DD-YYYY",
    "YYYY.MM.DD",
    "DD.MM.YYYY",
  ];

  if (input instanceof Date && !isNaN(input)) return input;

  if (typeof input === "number") {
    const parsed = moment(input);
    return parsed.isValid() ? parsed.toDate() : null;
  }

  const isoParsed = moment(input, moment.ISO_8601, true);
  if (isoParsed.isValid()) return isoParsed.toDate();

  for (const fmt of knownFormats) {
    const parsed = moment(input, fmt, true);
    if (parsed.isValid()) return parsed.toDate();
  }

  const loose = moment(input);
  return loose.isValid() ? loose.toDate() : null;
};

/**
 * Parses time inputs into JS Date objects.
 * Supports many time formats and guards against junk inputs.
 */
export const parseSafeMomentTime = (input) => {
  if (!input) return null;

  const knownTimeFormats = ["HH:mm", "hh:mm A", "h:mm A", "HH:mm:ss", "hh:mm:ss A", moment.ISO_8601];

  // Common invalid values
  const badValues = ["null", "undefined", "NaN", "invalid date", "null null", "00:60", "25:00"];
  const normalized = String(input).trim().toLowerCase();
  if (badValues.includes(normalized)) return null;

  // If input is already a valid Date object
  if (input instanceof Date && !isNaN(input)) return input;

  // If input is timestamp number
  if (typeof input === "number") {
    const parsed = moment(input);
    return parsed.isValid() ? parsed.toDate() : null;
  }

  // Try known time formats strictly
  for (const format of knownTimeFormats) {
    const parsed = moment(input, format, true);
    if (parsed.isValid()) return parsed.toDate();
  }

  // Fallback loose parse
  const loose = moment(input);
  return loose.isValid() ? loose.toDate() : null;
};
